import React, { ReactNode } from 'react';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import { Tool } from '../../types';
import './Layout.css';

interface LayoutProps {
  children: ReactNode;
  activeTool: string | null;
  tools: Tool[];
  onNavigate: (toolId: string | null) => void;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  activeTool,
  tools,
  onNavigate
}) => {
  const activatedTool = activeTool ? tools.find(tool => tool.id === activeTool) : null;
  
  return (
    <div className="layout">
      <Header 
        title={activatedTool ? activatedTool.name : "Catelyn Pet Shop Tools"} 
        onGoHome={() => onNavigate(null)}
        showHomeButton={!!activeTool}
      />
      
      <div className="layout-content">
        <Sidebar 
          tools={tools} 
          activeTool={activeTool} 
          onSelectTool={onNavigate} 
        />
        
        <main className="main-content">
          {children}
        </main>
      </div>
      
      <footer className="app-footer">
        <p>&copy; {new Date().getFullYear()} Catelyn Pet Shop. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default Layout;
